<template>
  <div>
    <!-- 设置页banner -->
    <div v-if="$route.name == 'MessageSwitch'" class="MerchantsDaybox">
      <div class="icon_box">
        <img :src="$OSSBaseUrl + 'MerchantsDay_laba.png'" alt="" />
      </div>
      <NoticeBar
        v-if="NoticeBarShow"
        class="banner"
        color="#FF5700"
        background="#FFECE2"
        speed="50"
        :text="banner_text"
      />
      <div class="button_box">
        <div @click="jump_link('MessageSwitch')" class="button">立即续费</div>
      </div>
    </div>
    <!-- 信息详情页banner -->
    <div
      @click="jump_link('CustomerInfo')"
      v-if="$route.name == 'CustomerInfo' && this.GetCustomerDetail['surplus_free_num']"
      class="MerchantsDay_banner_box"
    >
      <div v-if="GetCustomerDetail['surplus_free_num'] && GetCustomerDetail['surplus_free_num'] != 'paid'" class="BannerTips">
        免费试用接收消息已消耗：{{150 - parseInt(GetCustomerDetail['surplus_free_num']) }}条，剩余{{GetCustomerDetail['surplus_free_num']}}条
      </div>
      <img
        class="MerchantsDay_banner"
        :src="$OSSBaseUrl + (this.GetCustomerDetail['surplus_free_num'] == 'paid'?'SpecialDiscount_banner8.png':'SpecialDiscount_banner10.png')"
      />
    </div>
  </div>
</template>
<script>
import { NoticeBar, Toast } from "vant";
import { URL5,URL6 } from "@/utils/Redirect";
import { mapState } from "vuex";

export default {
  name: "MerchantsDay20210312",
  components: {
    NoticeBar,
    Toast
  },
  data() {
    return {
      banner_text:"高效客服管理工具特惠福利 最高折扣再8折！另每月赠送200条短信+50分钟通话，提高店铺排名点击获取福利优惠＞＞",
      NoticeBarShow:true,
      Link: '',
    };
  },
  computed: {
    ...mapState({
      UserInfo: (state) => {
        return state.Public.UserInfo;
      },
      GetCustomerDetail: (state) => {
        return state.CustomerInfo.GetCustomerDetail;
      },
    }),
  },
  mounted(){
    window.addEventListener("pageshow",()=>{
        this.NoticeBarShow=false
        setTimeout(()=>{
          this.NoticeBarShow=true
          
        },10)
    },false)
  },
  
  methods: {
    jump_link() {
      this.$store.dispatch("MessageSwitch/renew", {}).then(res=>{
        if(res.code == 1000) {
          if(this.$route.name == 'MessageSwitch'){
            if(this.UserInfo.serv_jump == 0 ){
              this.Link = URL5 // 千牛版banner跳转
            }else{
              this.Link = URL6 // 入端版banner跳转
            }
          }else{
            if(this.GetCustomerDetail.banner_url == 1 ){
              this.Link = URL5 // 千牛版banner跳转
            }else{
              this.Link = URL6 // 入端版banner跳转
            }
          }
          this.inH5Record()
          // window.location.href= this.Link
        }else {
          Toast(res.message)
        }
        
      });
      
     
    },
    inH5Record() {
      let data = {
        page_from: "main_page",
        page_name: this.$route.name,
        page_time: "0.00",
        btn_name: "立即续费",
        receiver_id: "",
        page_param: { btn_name: "renew_button" },
      };
      this.$store.dispatch("Public/inH5Record", data).then(res=>{
        window.location.href= this.Link
      });
    }
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>